// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { removeCartLineWithResult as xngRemoveCartLineApi } from "@bg/App/Services/CartService";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { sendRemoveFromCartEvent } from "@insite/client-framework/OdpEvents/UpdateCartEvents";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getCartLine } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadQuote from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import {
    chain,
    LoadCart,
    PopulateApiParameter,
    RemoveCartLine,
    SendRemoveFromCartEvent,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

type PropsType = Parameters<typeof PopulateApiParameter>[0];
type ParameterType = PropsType["parameter"];

type XngParameter = ParameterType & { cartId?: string; isQuoteLine?: boolean; reloadQuote?: boolean };

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const parameter = props.parameter as XngParameter;
    props.apiParameter = {
        cartLineId: props.parameter.cartLineId,
        cartId: parameter.cartId ? parameter.cartId : API_URL_CURRENT_FRAGMENT,
        isQuoteLine: parameter.isQuoteLine,
    } as { isQuoteLine?: boolean } & typeof props.apiParameter;
};

/**
 * XNG-Changes
 * Replace SendRemoveFromCartEvent
 */
export const XngSendRemoveFromCartEvent: typeof SendRemoveFromCartEvent = async props => {
    if ((props.parameter as { isQuoteLine?: boolean })?.isQuoteLine) {
        return;
    }

    const cartLineModel = await getCartLine({
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineId: props.parameter.cartLineId,
        expand: ["hiddenproducts"],
    });

    sendRemoveFromCartEvent(
        { productId: cartLineModel.productId!, qtyOrdered: cartLineModel.qtyOrdered! },
        props.getState(),
    );
};

/**
 * XNG-Changes
 * Replace the service
 */
export const XngRemoveCartLine: typeof RemoveCartLine = async props => {
    await xngRemoveCartLineApi(props.apiParameter);
};

export const XngLoadCart: typeof LoadCart = props => {
    const parameter = props.parameter as XngParameter;
    if (!parameter.reloadQuote || !parameter.cartId) {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    } else if (parameter.reloadQuote && parameter.cartId) {
        props.dispatch(loadQuote({ quoteId: parameter.cartId }));
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, SendRemoveFromCartEvent, XngSendRemoveFromCartEvent);
replaceInChain(chain, RemoveCartLine, XngRemoveCartLine);
replaceInChain(chain, LoadCart, XngLoadCart);
